const URL = {
  API_KEYS: 'api-keys',
  API_KEY_BY_ID: 'api-keys/{id}',
}

export default URL
